if (!customElements.get('newsletter-section')) {
  customElements.define(
    'newsletter-section',
    class NewsletterSection extends HTMLElement {
      constructor() {
        super()
        this.input = this.querySelector('[type="email"]')
        this.ageBox = this.querySelector('[type="checkbox"]')
        this.submitBtn = this.querySelector('[type="submit"]')
        this.form = this.querySelector('form')
        this.message = this.querySelector('[data-message]')
        this.initEvents()
      }

      initEvents() {
        this.submitBtn.addEventListener('click', (e) => {
          if (!this.checkFormVaildate()) {
            e.preventDefault()
            if (this.message) this.message.remove()
            this.form.innerHTML += `<small class="newsletter-message relative block text-center lg:text-left lg:absolute lg:left-0 bg-black -mx-8 lg:mx-0 mt-12 lg:mt-0 pl-12 pr-6 py-2 mt-8 lg:mt-0" data-message>Invalid Email Address</small>`
            this.message = this.querySelector('[data-message]')
            this.formMessageWidth()
          }
        })

        this.ageBox.addEventListener('input', (e) => {
          if (e.target.checked) {
            this.submitBtn.classList.add('text-white')
            this.submitBtn.classList.remove('text-puffco-grey-3')
          } else {
            this.submitBtn.classList.remove('text-white')
            this.submitBtn.classList.add('text-puffco-grey-3')
          }
        })

        window.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' && !this.checkFormVaildate()) e.preventDefault()
        })
        setTimeout(() => {
          if (location.hash.includes('#contact_form') && this.form) this.form.scrollIntoView({ behavior: 'smooth' })
        }, 800)
        this.formMessageWidth()
        window.addEventListener('resize', (e) => {
          this.formMessageWidth()
        })
      }

      formMessageWidth() {
        if (this.message) {
          if (window.innerWidth >= 1024)
            this.message.setAttribute('style', `width: calc( 100vw - ${this.form.getBoundingClientRect().x + 1}px )`)
          else this.message.setAttribute('style', '')
        }
      }

      checkFormVaildate() {
        return this.ageBox.checked && this.validateEmail(this.input.value)
      }

      validateEmail(email) {
        return email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        )
      }
    },
  )
}
